import { useQuery } from '@tanstack/react-query';
import { adsApi } from '@/api/client';
import type { Portfolio } from '@/types/portfolios';

function parsePortfolios(data: unknown): Portfolio[] {
  if (!data || typeof data !== 'object') return [];
  const root = data as Record<string, unknown>;
  const list = Array.isArray(root.portfolios) ? root.portfolios : [];
  return list.filter((item): item is Portfolio => !!item && typeof item === 'object');
}

export function PortfolioSelect({
  profileId,
  value,
  onChange,
  disabled,
}: {
  profileId: string;
  value: string;
  onChange: (portfolioId: string) => void;
  disabled?: boolean;
}) {
  const { data, isLoading } = useQuery({
    queryKey: ['portfolios', profileId],
    queryFn: () => adsApi.listPortfolios(profileId),
    enabled: Boolean(profileId),
  });
  const portfolios = parsePortfolios(data?.data).filter(
    (p) => String(p.state || '').toUpperCase() !== 'ARCHIVED'
  );

  return (
    <div>
      <label className="block text-sm font-medium text-foreground-muted mb-1">Portfolio</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border border-border rounded-lg px-3 py-2 text-sm"
        disabled={disabled || isLoading}
      >
        <option value="">No portfolio</option>
        {portfolios.map((p) => (
          <option key={p.portfolioId} value={p.portfolioId}>
            {p.name || p.portfolioId}
          </option>
        ))}
      </select>
    </div>
  );
}
